import { Injectable } from "@angular/core";
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { emptyDatiqDatadogRumConfig } from "../models";
// import { IIqUser } from "@dat/iq-proxy";

@Injectable({
    providedIn: 'root',
})
export class DatiqDatadogRumService {

    init(config: RumInitConfiguration): void {
        if (!config.env || !config.clientToken || !config.applicationId) {
            console.error('Missing required Datadog RUM parameters.');
            return;
        }
        const initConfig: RumInitConfiguration = {
            ...emptyDatiqDatadogRumConfig,
            ...config,
        };
        datadogRum.init(initConfig);
    }

    setUser(user: any): void {
        const id: string = user.id ?? 'unknown';
        const name: string = user.oAuthProfile?.name ?? 'unknown';
        const email: string = user.oAuthProfile?.emailAddress ?? 'unknown';

        const csbId: number | undefined = user.oAuthProfile?.csbId;

        datadogRum.setUser({
            id,
            name,
            email,
            csbId
        })
    }

    startDurationVital(name: string, options?: any): any /* DurationVitalReference */ {
        const ref = datadogRum.startDurationVital(name);
        return ref;
    }

    stopDurationVital(nameOrRef: any /* string | DurationVitalReference */) {
        datadogRum.stopDurationVital(nameOrRef);
    }

    addFeatureFlagEvaluation(key: string, value: string): void {
        datadogRum.addFeatureFlagEvaluation(key, value);
    }

    addAction(name: string, opts: any = {}) {
        datadogRum.addAction(name, opts);
    }
}